import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Repeat = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 17.5H4V6.5H11.8L11 7.3C10.8 7.5 10.7 7.7 10.7 8C10.7 8.6 11.1 9 11.7 9C12 9 12.2 8.9 12.4 8.7L14.9 6.2C15.3 5.8 15.3 5.2 14.9 4.8L12.4 2.3C12 1.9 11.4 1.9 11 2.3C10.6 2.7 10.6 3.3 11 3.7L11.8 4.5H3C2.4 4.5 2 4.9 2 5.5V18.5C2 19.1 2.4 19.5 3 19.5H5.5C6.1 19.5 6.5 19.1 6.5 18.5C6.5 17.9 6.1 17.5 5.5 17.5ZM21 4.5H18.5C17.9 4.5 17.5 4.9 17.5 5.5C17.5 6.1 17.9 6.5 18.5 6.5H20V17.5H11.6L12.4 16.7C12.8 16.3 12.8 15.7 12.4 15.3C12 14.9 11.4 14.9 11 15.3L8.5 17.8C8.1 18.2 8.1 18.8 8.5 19.2L11 21.7C11.2 21.9 11.4 22 11.7 22C12 22 12.2 21.9 12.4 21.7C12.8 21.3 12.8 20.7 12.4 20.3L11.6 19.5H21C21.6 19.5 22 19.1 22 18.5V5.5C22 4.9 21.6 4.5 21 4.5Z"
      fill="currentColor"
    />
  </svg>
)

export default Repeat
